import { DmData, DmDataFactoryFromJS, IDmData } from '@bimser/common';
import { IDictionary, createSyncAction } from '@bimser/core';
import { List, Map } from 'immutable';
import { IWebInterfaceAction, WebInterfaceActionFactoryFromJS } from '../../../common/entities';
import {
	Announcement,
	AnnouncementFactoryFromJS,
	IAnnouncement
} from '../../announcements/entities';
import { DashboardFormData } from '../entities/IDashboardFormData';
import { TileTypes } from '../entities/widgets/TileTypes';
import { IProcess, Process, ProcessFactoryFromJS } from '../entities/widgets/model/types/IProcess';
import * as ActionTypes from './actionTypes';
import {
	IRecentAppItem,
	RecentAppItemFactoryFromJS
} from '../entities/widgets/model/types/IRecentAppItem';

export const refreshDashboardDataTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.REFRESH_DASHBOARD_DATA_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const setDashboardWillRefreshDataAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_DASHBOARD_WILL_REFRESH_DATA_ACTION, data);

// #RecentApps
export const setRecentAppsDataAction = (data: Array<IRecentAppItem>) => {
	const _data = data.map(item => RecentAppItemFactoryFromJS(item));

	return createSyncAction(ActionTypes.SET_RECENT_APPS_DATA_ACTION, List(_data));
};

export const setRecentAppsLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_RECENT_APPS_LOADING_ACTION, data);

export const setIsPinningRecentAppAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_IS_PINNING_RECENT_APP_ACTION, data);

export const onClickRecentAppTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_RECENT_APP_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const pinRecentAppTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(ActionTypes.PIN_RECENT_APP_TRANSACTION, WebInterfaceActionFactoryFromJS(data));

// #Tiles
export const setTilesCountsAction = (data: IDictionary<number>) =>
	createSyncAction(ActionTypes.SET_TILES_COUNTS_ACTION, Map(data));

export const setTilesLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_TILES_LOADING_ACTION, data);

export const setSelectedTileAction = (data: TileTypes) =>
	createSyncAction(ActionTypes.SET_SELECTED_TILE_ACTION, data);

export const onChangeSelectedTileTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CHANGE_SELECTED_TILE_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

// #RecentFiles
export const setRecentFilesDataAction = (data: Array<IDmData>) => {
	const _data: Array<DmData> = data.map((item: IDmData) => DmDataFactoryFromJS(item));

	return createSyncAction(ActionTypes.SET_RECENT_FILES_DATA_ACTION, List(_data));
};

export const setRecentFilesLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_RECENT_FILES_LOADING_ACTION, data);

export const onClickRecentFileTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_RECENT_FILE_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

// #Announcements
export const setAnnouncementsDataAction = (data: Array<IAnnouncement>) => {
	const _data: Array<Announcement> = data.map((item: IAnnouncement) =>
		AnnouncementFactoryFromJS(item)
	);

	return createSyncAction(ActionTypes.SET_ANNOUNCEMENTS_DATA_ACTION, List(_data));
};

export const setAnnouncementsLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_ANNOUNCEMENTS_LOADING_ACTION, data);

export const onClickAnnouncementTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_ANNOUNCEMENT_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const onClickAllAnnouncementsTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_ALL_ANNOUNCEMENTS_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

// #Proccesses
export const insertProcessesDataAction = (data: { data: Array<IProcess>; hasMore: boolean }) => {
	const _data: List<Process> = List(
		data.data.map((item: IProcess) => ProcessFactoryFromJS(item))
	);

	return createSyncAction(
		ActionTypes.INSERT_PROCESSES_DATA_ACTION,
		Map({ data: _data, hasMore: data.hasMore })
	);
};

export const resetProcessesDataAction = () =>
	createSyncAction(ActionTypes.RESET_PROCESSES_DATA_ACTION, undefined);

export const onClickProcessTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_PROCESS_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const onLoadProcessesTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_LOAD_PROCESSES_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const setProcessesLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_PROCESSES_LOADING_ACTION, data);

export const setSelectedProcessAction = (selected: IProcess) =>
	createSyncAction(ActionTypes.SET_SELECTED_PROCESS_ACTION, ProcessFactoryFromJS(selected));

export const resetSelectedProcessAction = () =>
	createSyncAction(ActionTypes.RESET_SELECTED_PROCESS_ACTION, undefined);

export const updateProcessAction = (data: IProcess) =>
	createSyncAction(ActionTypes.UPDATE_PROCESS_ACTION, ProcessFactoryFromJS(data));

export const removeProcessAction = (data: IProcess) =>
	createSyncAction(ActionTypes.REMOVE_PROCESS_ACTION, ProcessFactoryFromJS(data));

// #Proccess Details

export const onClickProcessDetailTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_CLICK_PROCESS_DETAIL_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const onLoadProcessDetailsTransaction = (data: IWebInterfaceAction) =>
	createSyncAction(
		ActionTypes.ON_LOAD_PROCESS_DETAILS_TRANSACTION,
		WebInterfaceActionFactoryFromJS(data)
	);

export const setProcessDetailsLoadingAction = (data: boolean) =>
	createSyncAction(ActionTypes.SET_PROCESS_DETAILS_LOADING_ACTION, data);

export const setPendingFastApproveDocumentCount = (data: number) =>
	createSyncAction(ActionTypes.SET_PENDING_FAST_APPROVE_DOCUMENT_COUNT_ACTION, data);

export const setDashboardFormDataAction = (data: DashboardFormData) =>
	createSyncAction(ActionTypes.SET_DASHBOARD_FORM_DATA_ACTION, data);

export const setDashboardPanelId = (panelId: string) =>
	createSyncAction(ActionTypes.SET_DASHBOARD_PANEL_ID, panelId);
